import UnifiedLightboxModal from '@components/unified-lightbox/Lightbox';
import { openUnifiedLightboxAtom } from '@components/unified-lightbox/atoms';
import { getFilterByMediaType } from '@components/unified-lightbox/helpers';
import type { UnifiedLightboxTrackingEvents } from '@components/unified-lightbox/hooks/use-track-unified-lightbox';
import useImage from '@hooks/useImage';
import type { useInlineRfqForm } from '@tkmp/rfq/hooks/useInlineRfqForm/useInlineRfqForm';
import { useSetAtom } from 'jotai';
import React, { type FC, useCallback, useState } from 'react';
import { afterNextPaint } from '../../../../../../../../helpers/after-next-paint';
import ImageWrapper from '../../../../../components/Media/ImageWrapper';
import { PLACEHOLDER_CONSTANTS } from '../../../../../components/Media/constants';
import Playable, {
	type PlayableRenderProps,
} from '../../../../../components/Media/playable';
import { getMediaQuickTileText } from './helpers';
import Styles from './styles.scss';
export interface MobileGalleryQuickLinkItemProps {
	mediaBucket: Vendor.Media[];
	trackQuicklinksClick: (type: string) => void;
	context?: ReturnType<typeof useInlineRfqForm>;
	trackingEvents?: UnifiedLightboxTrackingEvents;
}

export const MobileGalleryQuickLinkItem: FC<MobileGalleryQuickLinkItemProps> = (
	props,
) => {
	const [imageStatus, onLoad, onError] = useImage(PLACEHOLDER_CONSTANTS.url);
	const [isUnifiedLightboxModalOpen, setIsUnifiedLightboxModalOpen] =
		useState<boolean>(false);

	const { mediaBucket, trackQuicklinksClick, context, trackingEvents } = props;
	const setOpenUnifiedLightbox = useSetAtom(openUnifiedLightboxAtom);

	const mediaItem = mediaBucket[0];
	const { mediaType } = mediaItem;

	const onClick = useCallback(async () => {
		afterNextPaint(() => {
			setOpenUnifiedLightbox({
				indexInAllMedia: 0,
				filter: getFilterByMediaType(mediaType),
				trackingEvents: trackingEvents,
			});
			setIsUnifiedLightboxModalOpen(true);
			trackQuicklinksClick(mediaType);
		});
	}, [mediaType, setOpenUnifiedLightbox, trackQuicklinksClick, trackingEvents]);

	const tileWidth = 125;
	const tileHeight = 100;

	const placeholderContent = (
		<span className={Styles.quickLinkItemPlaceholderText}>
			{' '}
			Preview Unavailable{' '}
		</span>
	);

	return (
		<Playable
			media={mediaItem}
			render={({ playMedia, stopMedia }: PlayableRenderProps) => {
				return (
					<>
						<div
							role="button"
							onClick={onClick}
							onKeyDown={onClick}
							tabIndex={0}
							className={Styles.quickLinkContainer}
							data-context="quicklink"
						>
							<ImageWrapper
								imageClass={Styles.quickLinksImage}
								placeholderClass={Styles.quickLinkItemPlaceholder}
								placeholderContent={placeholderContent}
								imageStatus={imageStatus}
								mediaItem={mediaItem}
								onError={onError}
								onLoad={onLoad}
								height={tileHeight}
								width={tileWidth}
								smartCrop
							/>
							<span className={Styles.quickLinkText}>
								{getMediaQuickTileText(mediaBucket)}
							</span>
						</div>
						{isUnifiedLightboxModalOpen && (
							<UnifiedLightboxModal
								entryPoint="Quicklinks"
								isModalOpen={isUnifiedLightboxModalOpen}
								closeCallback={() => setIsUnifiedLightboxModalOpen(false)}
							/>
						)}
					</>
				);
			}}
		/>
	);
};
